/* eslint-disable @next/next/no-img-element */
import Filter from '@alltrails/denali/icons/Filter';
import Hiking from '@alltrails/denali/icons/Hiking';
import List from '@alltrails/denali/icons/List';
import Map from '@alltrails/denali/icons/Map';
import Place from '@alltrails/denali/icons/Place';
import Park from '@alltrails/denali/icons/PlacePark';
import Trail from '@alltrails/denali/icons/PlaceTrail';
import Record from '@alltrails/denali/icons/Record';
import Shield from '@alltrails/denali/icons/Shield';
import TrailDog from '@alltrails/denali/icons/TrailDog';
import Waterfall from '@alltrails/denali/icons/Waterfall';
import type { AlgoliaSearchResult } from '@alltrails/types/AlgoliaResults';
import getPOIIcon from '../../utils/getPOIIcon';
import getSizedSponsoredListImageUrl from '../../utils/getSizedSponsoredListImageUrl';

export type ResultIconProps = {
  result: AlgoliaSearchResult;
};

const ResultIcon = ({ result }: ResultIconProps) => {
  switch (result.type) {
    case 'area':
      return result.area_type === 'N' ? <Shield color="--color-text-secondary" /> : <Park color="--color-text-secondary" />;
    case 'filter':
      if (result.filters?.activity?.includes('hiking')) {
        return <Hiking color="--color-text-secondary" />;
      }
      if (result.filters?.suitability?.includes('dogs')) {
        return <TrailDog color="--color-text-secondary" />;
      }
      if (result.filters?.feature?.includes('waterfall')) {
        return <Waterfall color="--color-text-secondary" />;
      }
      return <Filter color="--color-text-secondary" />;
    case 'guide':
      return <img src={`${result.photo_url}?size=96w96h`} alt="" data-testid={`guide-result-image-${result.ID}`} />;
    case 'list':
      return <List color="--color-text-secondary" />;
    case 'map':
      return <Map color="--color-text-secondary" />;
    case 'page':
      return <img src={result.image_url} alt="" data-testid={`page-result-image-${result.ID}`} />;
    case 'place':
      return <Place color="--color-text-secondary" />;
    case 'poi': {
      const Icon = getPOIIcon(result.subtype);
      return <Icon color="--color-text-secondary" />;
    }
    case 'sponsored_list':
      return <img src={getSizedSponsoredListImageUrl(result.photo_url, 96, 96)} alt="" />;
    case 'track':
      return <Record color="--color-text-secondary" />;
    case 'trail':
      return <Trail color="--color-text-secondary" />;
    default:
      return null;
  }
};

export default ResultIcon;
